import './component.scss'

// 画像を一括で読み込み（png/jpg両方対応）
const images = require.context('./images', false, /\.(png|jpg)$/)
images.keys().forEach(images)
